import { render, staticRenderFns } from "./PatientOverviewPAGoalSettingStrengthTraining.vue?vue&type=template&id=928391d6&"
import script from "./PatientOverviewPAGoalSettingStrengthTraining.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewPAGoalSettingStrengthTraining.vue?vue&type=script&lang=js&"
import style0 from "./PatientOverviewPAGoalSettingStrengthTraining.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow})
